"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserVideoSession = exports.usePositionOffset = exports.useFullScreen = exports.getControlEventHandler = exports.deleteVideoCall = exports.createVideoCall = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _utils = require("../../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var createVideoCall = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(roomId, connectionId, bookingId) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _utils.api.post((0, _utils.getVideoCallStartUrl)(roomId), {
              connectionId: connectionId,
              bookingId: bookingId
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function createVideoCall(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// used on page unload so navigator.sendBeacon is applied
exports.createVideoCall = createVideoCall;
var deleteVideoCall = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sessionId, connectionId) {
    var isUnload,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isUnload = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
            return _context2.abrupt("return", isUnload ? window.navigator.sendBeacon((0, _utils.deleteVideoCallUrl)(sessionId, connectionId)) : _utils.api.post((0, _utils.deleteVideoCallUrl)(sessionId, connectionId)));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function deleteVideoCall(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

// With react-draggable as a parent component,
// when dragging is enabled, the parent component
// interferes with tapping events on touch-enabled devices.
// Need to provide onTouchStart in addition to onClick
exports.deleteVideoCall = deleteVideoCall;
var getControlEventHandler = function getControlEventHandler(isVideoMinimized) {
  return function (cb) {
    // For mobile devices
    // fullscreen - fires touchstart and click
    // maximized - fires touchstart and click
    // minimized - fires touchstart

    // For desktop
    // fullscreen - fires click
    // maximized - fires click
    // minimized - fires click
    return function (event) {
      // Only let through click events
      // or all events when video is minimized,
      // because when minimized only one type
      // of relevant UI event is fired
      if (isVideoMinimized || event.type === 'click') {
        cb(event);
      }
    };
  };
};

// Helper because getBoundingClientRect().toJSON() is non-standard
// https://stackoverflow.com/a/48632087/712895
exports.getControlEventHandler = getControlEventHandler;
var getBoundingClientRect = function getBoundingClientRect(element) {
  var _element$getBoundingC = element.getBoundingClientRect(),
    top = _element$getBoundingC.top,
    right = _element$getBoundingC.right,
    bottom = _element$getBoundingC.bottom,
    left = _element$getBoundingC.left,
    width = _element$getBoundingC.width,
    height = _element$getBoundingC.height,
    x = _element$getBoundingC.x,
    y = _element$getBoundingC.y;
  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: x,
    y: y
  };
};
var usePositionOffset = function usePositionOffset(isMaximized) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    offset = _useState2[0],
    setOffset = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    anchor = _useState4[0],
    setAnchor = _useState4[1];
  var updatePosSize = (0, _react.useMemo)(function () {
    return (0, _lodash.debounce)(function () {
      var bound = anchor && getBoundingClientRect(anchor);
      var hasSize = !!(bound !== null && bound !== void 0 && bound.height && bound !== null && bound !== void 0 && bound.width);
      var newOffset = hasSize ? bound : {
        height: '',
        left: '',
        width: '',
        top: ''
      };
      if (!(0, _lodash.isEqual)(offset, newOffset)) {
        setOffset(newOffset);
      }
    }, 200);
  }, [offset, anchor]);
  (0, _react.useEffect)(function () {
    if (anchor) {
      anchor.addEventListener('resize', updatePosSize);
      anchor.addEventListener('move', updatePosSize);
      updatePosSize();
    }
  }, [updatePosSize, anchor]);
  (0, _react.useEffect)(function () {
    updatePosSize();
  }, [anchor === null || anchor === void 0 ? void 0 : anchor.parentElement, updatePosSize, isMaximized]);
  (0, _react.useEffect)(function () {
    window.addEventListener(_utils.VIDEO_CHAT_EVENTS.RESIZE, updatePosSize);
    window.addEventListener(_utils.VIDEO_CHAT_EVENTS.VIDEO_ANCHOR_MOUNT, updatePosSize);
    window.addEventListener(_utils.VIDEO_CHAT_EVENTS.VIDEO_ANCHOR_UNMOUNT, updatePosSize);
    window.addEventListener(_utils.VIDEO_CHAT_EVENTS.VIDEO_INTERVAL_UPDATE, updatePosSize);
    return function () {
      window.removeEventListener(_utils.VIDEO_CHAT_EVENTS.RESIZE, updatePosSize);
      window.removeEventListener(_utils.VIDEO_CHAT_EVENTS.VIDEO_ANCHOR_MOUNT, updatePosSize);
      window.removeEventListener(_utils.VIDEO_CHAT_EVENTS.VIDEO_ANCHOR_UNMOUNT, updatePosSize);
      window.removeEventListener(_utils.VIDEO_CHAT_EVENTS.VIDEO_INTERVAL_UPDATE, updatePosSize);
    };
  }, [updatePosSize]);
  return {
    anchor: anchor,
    containerOffset: offset,
    setAnchor: setAnchor
  };
};
exports.usePositionOffset = usePositionOffset;
var fullScreenMethodSets = [['requestFullscreen', 'exitFullscreen', 'fullscreenchange', 'fullscreenElement'], ['mozRequestFullScreen', 'mozExitFullScreen', 'mozfullscreenchange', 'mozFullScreenElement'], ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitfullscreenchange', 'webkitFullscreenElement'], ['msRequestFullscreen', 'msExitFullscreen', 'msfullscreenchange', 'msFullscreenElement']];
var useFullScreen = function useFullScreen() {
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFullScreen = _useState6[0],
    setIsFullScreen = _useState6[1];
  var _useMemo = (0, _react.useMemo)(function () {
      return fullScreenMethodSets.find(function (methods) {
        return (0, _lodash.get)(document, methods[1]);
      }) || [];
    }, []),
    _useMemo2 = _slicedToArray(_useMemo, 4),
    requestMethod = _useMemo2[0],
    exitMethod = _useMemo2[1],
    onChangeHandler = _useMemo2[2],
    elementField = _useMemo2[3];
  var toggleFullScreen = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var element;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (requestMethod) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            if (!isFullScreen) {
              _context3.next = 7;
              break;
            }
            _context3.next = 5;
            return document[exitMethod]();
          case 5:
            _context3.next = 10;
            break;
          case 7:
            element = document.getElementById('videoChat');
            _context3.next = 10;
            return element[requestMethod]();
          case 10:
            setIsFullScreen(function (s) {
              return !s;
            });
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [exitMethod, isFullScreen, requestMethod]);
  (0, _react.useEffect)(function () {
    var handleFullScreenChange = function handleFullScreenChange() {
      if (!document[elementField]) {
        setIsFullScreen(false);
      }
    };
    document.addEventListener(onChangeHandler, handleFullScreenChange);
    return function () {
      document.removeEventListener(onChangeHandler, handleFullScreenChange);
    };
  }, []);
  return {
    isFullScreen: isFullScreen,
    toggleFullScreen: toggleFullScreen
  };
};

// handling case when call becomes forbidden during clinician's session (patient unsubscribed)
exports.useFullScreen = useFullScreen;
var getVideoCallInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(userId) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _utils.apiWithoutErrorsHandler.get((0, _utils.getVideoCallUrl)(userId)).then(function (res) {
              return res;
            }).catch(function (error) {
              if (error.response.status === 403) {
                window.location.reload();
              }
              throw error;
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function getVideoCallInfo(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
var useUserVideoSession = function useUserVideoSession(user, onStart) {
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    data = _useState8[0],
    setData = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isUnfinishedCall = _useState10[0],
    setIsUnfinishedCall = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loading = _useState12[0],
    setLoading = _useState12[1];
  (0, _react.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$getVideoCallIn, _data, roomId;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                setLoading(true);
                setIsUnfinishedCall(false);
                _context5.prev = 2;
                _context5.next = 5;
                return getVideoCallInfo(user.id);
              case 5:
                _yield$getVideoCallIn = _context5.sent;
                _data = _yield$getVideoCallIn.data;
                setData(_data);
                _context5.next = 15;
                break;
              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](2);
                roomId = (0, _lodash.get)(_context5.t0.response, 'data.details.roomId');
                setIsUnfinishedCall(true);
                setData({
                  roomId: roomId
                });
              case 15:
                _context5.prev = 15;
                setLoading(false);
                return _context5.finish(15);
              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 10, 15, 18]]);
      }));
      return function fetch() {
        return _ref5.apply(this, arguments);
      };
    }();
    if (user !== null && user !== void 0 && user.id) {
      fetch();
    } else {
      setData({});
    }
  }, [user]);
  (0, _react.useEffect)(function () {
    if (data && onStart) {
      onStart();
    }
  }, [onStart, data]);
  return _objectSpread(_objectSpread({}, data), {}, {
    isUnfinishedCall: isUnfinishedCall,
    loading: loading
  });
};
exports.useUserVideoSession = useUserVideoSession;